module.exports = __webpack_public_path__ + "img/jt.a42a983b.png";